import Button from "../controls/Button";

import {
  AUDIT_HISTORIES_LINK_LABEL,
  AUDIT_HISTORIES_LINK_REL,
  AUDIT_HISTORIES_LINK_TARGET,
  buildAuditHistoriesUrl,
} from "./auditEntityConfig";

export default function AuditHistoriesLink({ slug, className = "" }) {
  return (
    <Button
      variant="secondary"
      to={buildAuditHistoriesUrl(slug)}
      target={AUDIT_HISTORIES_LINK_TARGET}
      rel={AUDIT_HISTORIES_LINK_REL}
      className={
        className
          ? `ml-2 h-10 border-gray-300 text-gray-700 hover:bg-gray-50 ${className}`
          : "ml-2 h-10 border-gray-300 text-gray-700 hover:bg-gray-50"
      }
    >
      {AUDIT_HISTORIES_LINK_LABEL}
    </Button>
  );
}
